module.exports = __webpack_public_path__ + "static/img/fyb_zbx.fe3405b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fyb_zbx.gif
// module id = ECLo
// module chunks = 1